/**
 * @class notificationConstants
 *
 * do not use the tableConstantFactory because we only need a limited set of constants
 */
const notificationConstants = {};
notificationConstants.CREATE = 'NOTIFICATION_CREATE';
notificationConstants.CREATE_MODAL = 'NOTIFICATION_CREATE_MODAL';
notificationConstants.DISMISS = 'NOTIFICATION_DISMISS';

// the following constants are used to identifiy a specific type of notification.
// they are not intended for redux actions
notificationConstants.VALIDATION_ERROR = 'validation-error';
notificationConstants.UNSAVED_CHANGES_WARNING = 'unsaved_changes_warning';
export default notificationConstants;